module.exports = __webpack_public_path__ + "img/expar_logo_new2.81ced4e0.svg";